<template>
  <el-checkbox v-model="value" @update:modelValue="input">
    Block returned traffic
    <IconWithHint>
      If a network wins, but for some reason<br />
      returns the visitor back, and your bid is next,<br />
      you can filter it.
    </IconWithHint>
  </el-checkbox>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import IconWithHint from '@/components/IconWithHint.vue'

export default defineComponent({
  name: 'BlockReturned',
  components: {
    IconWithHint
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const input = (newValue: boolean) => {
      context.emit('update:modelValue', newValue)
    }

    return { input, value }
  }
})
</script>
